import * as React from 'react';
import {
  Paper,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function StepSidebar({ steps, activeStep, currentStepIndex, stepOrder, validateStep, validationErrors, onStepClick }) {
  return (
    <Paper
      elevation={0}
      sx={{
        width: 280,
        minHeight: '400px',
        borderRadius: '8px',
        background: 'white',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        padding: '16px 0',
      }}
    >
      <List sx={{ padding: 0 }}>
        {steps.map((step) => {
          const isActive = activeStep === step.id;
          const stepIndex = stepOrder.indexOf(step.id);
          const isCompleted = stepIndex < currentStepIndex;
          const stepHasErrors = Object.keys(validateStep(step.id)).length > 0 && Object.keys(validationErrors).length > 0;

          return (
            <ListItem key={step.id} disablePadding>
              <ListItemButton
                onClick={() => onStepClick(step.id)}
                sx={{
                  paddingLeft: '20px',
                  paddingRight: '16px',
                  minHeight: '48px',
                  backgroundColor: isActive ? 'rgba(102, 126, 234, 0.12)' : 'transparent',
                  borderRight: isActive ? '4px solid #667eea' : '4px solid transparent',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: isActive ? 'rgba(102, 126, 234, 0.16)' : 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                {stepHasErrors ? (
                  <ErrorOutlineIcon
                    sx={{ color: '#d32f2f', fontSize: '20px', marginRight: '12px' }}
                  />
                ) : isCompleted && !isActive ? (
                  <CheckCircleIcon
                    sx={{ color: '#667eea', fontSize: '20px', marginRight: '12px' }}
                  />
                ) : null}
                <ListItemText
                  primary={step.label}
                  sx={{
                    '& .MuiListItemText-primary': {
                      fontSize: '0.9rem',
                      fontWeight: isActive ? 600 : 400,
                      color: stepHasErrors ? '#d32f2f' : isActive ? '#667eea' : '#64748b',
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
}

export default StepSidebar;
